export const GET_REQUEST = "GET_REQUEST"
export const GET_SUCCESS = "GET_SUCCESS"
export const GET_FAILURE = "GET_FAILURE"


export const ADD_REQUEST = "ADD_REQUEST"
export const ADD_SUCCESS = "ADD_SUCCESS"
export const ADD_FAILURE = "ADD_FAILURE"